import { Button } from '@cmsgov/ds-medicare-gov'
import { ContentLayout } from 'components/Layouts'
import DrugCard from 'components/rxDrugCard/DrugCard'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDrugPlanInfo } from './useDrugPlanInfo'

import classes from './RxDrugCard.module.css'
import { useQueryParams } from 'hooks/useQueryParams'
import { CoveragePlanStatus } from '@cms-max/medicare-api-sdk'
import { useEvent } from 'hooks/useEvent'

export function RxDrugCard () {
  const { t } = useTranslation('rxDrugCard')
  const { fireEvent } = useEvent('rxDrugCard')

  const queryParams = useQueryParams()
  const status = queryParams.get('status') as CoveragePlanStatus | null

  const { isLoading, data } = useDrugPlanInfo(status || undefined)

  const handlePrint = useCallback(() => {
    fireEvent('prescriptiondrugcard_print_click')

    window.print()
  }, [fireEvent])

  return (
    <ContentLayout
      heading={t('heading')}
      width="wide"
      className={classes.printable}
    >
      <div className="ds-l-container">
        <p>{t('description')}</p>

        {data && <DrugCard {...data} isLoading={isLoading} />}

        <div className="ds-u-margin-top--3">
          <Button
            variation="solid"
            size="big"
            onClick={handlePrint}
            className="ds-u-visibility--hidden-print"
          >
            {t('printButton')}
          </Button>
        </div>
      </div>
    </ContentLayout>
  )
}

export default RxDrugCard
